module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst meta = (model.documentData || {}).meta || {}\nconst document = meta.document || {}\nconst vat           = utils.number.format((document.vat || 0) * 100, { decimals: 0}, 'float').formatted\nconst sumNetPrice   = utils.number.format(document.sumNetPrice || 0, { decimals: 2}, 'float').formatted\nconst sumPrice      = utils.number.format(document.sumPrice || 0, { decimals: 2}, 'float').formatted\nconst sumVat        = utils.number.format((document.sumPrice || 0) - (document.sumNetPrice || 0), { decimals: 2}, 'float').formatted\nconst baseUrl = String((((((storage || {}).app || {}).service || {}).config || {}).backOffice || {}).documentBaseUrl || '').replace(/\\/+$/g, '')\nconst termsPath = String((((((storage || {}).app || {}).service || {}).config || {}).backOffice || {}).termsPath || '').replace(/^\\/+/g, '/')\nconst termsUrl = `${baseUrl}${termsPath}`\n%><div>\n<table cellpadding=\"0\" cellspacing=\"0\">\n<tbody>\n<tr class=\"netPrice\">\n<td class=\"title\">&nbsp;</td>\n<td class=\"vat\">&nbsp;</td>\n<td class=\"amount\"><div><%= sumNetPrice %></div></td>\n</tr>\n<tr class=\"vatPrice\">\n<td class=\"title\">&nbsp;</td>\n<td class=\"vat\"><%- storage.__('document.offer.vat', { value: vat }) %></td>\n<td class=\"amount\"><div><%= sumVat %></div></td>\n</tr>\n<tr class=\"sum\">\n<td class=\"title\"><%- storage.__('document.offer.sum') %></td>\n<td class=\"vat\">&nbsp;</td>\n<td class=\"amount\"><div><%= sumPrice %></div></td>\n</tr>\n</tbody>\n</table>\n<div class=\"additionalInformation\">\n<%- String(model.additionalInformation).replace('{{termsUrl}}', termsUrl) %>\n</div>\n</div>"
  , __filename = "components/templates/core/documents/offer/summary.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const meta = (model.documentData || {}).meta || {}
const document = meta.document || {}
const vat           = utils.number.format((document.vat || 0) * 100, { decimals: 0}, 'float').formatted
const sumNetPrice   = utils.number.format(document.sumNetPrice || 0, { decimals: 2}, 'float').formatted
const sumPrice      = utils.number.format(document.sumPrice || 0, { decimals: 2}, 'float').formatted
const sumVat        = utils.number.format((document.sumPrice || 0) - (document.sumNetPrice || 0), { decimals: 2}, 'float').formatted
const baseUrl = String((((((storage || {}).app || {}).service || {}).config || {}).backOffice || {}).documentBaseUrl || '').replace(/\/+$/g, '')
const termsPath = String((((((storage || {}).app || {}).service || {}).config || {}).backOffice || {}).termsPath || '').replace(/^\/+/g, '/')
const termsUrl = `${baseUrl}${termsPath}`

    ; __line = 11
    ; __append("<div>\n<table cellpadding=\"0\" cellspacing=\"0\">\n<tbody>\n<tr class=\"netPrice\">\n<td class=\"title\">&nbsp;</td>\n<td class=\"vat\">&nbsp;</td>\n<td class=\"amount\"><div>")
    ; __line = 17
    ; __append(escapeFn( sumNetPrice ))
    ; __append("</div></td>\n</tr>\n<tr class=\"vatPrice\">\n<td class=\"title\">&nbsp;</td>\n<td class=\"vat\">")
    ; __line = 21
    ; __append( storage.__('document.offer.vat', { value: vat }) )
    ; __append("</td>\n<td class=\"amount\"><div>")
    ; __line = 22
    ; __append(escapeFn( sumVat ))
    ; __append("</div></td>\n</tr>\n<tr class=\"sum\">\n<td class=\"title\">")
    ; __line = 25
    ; __append( storage.__('document.offer.sum') )
    ; __append("</td>\n<td class=\"vat\">&nbsp;</td>\n<td class=\"amount\"><div>")
    ; __line = 27
    ; __append(escapeFn( sumPrice ))
    ; __append("</div></td>\n</tr>\n</tbody>\n</table>\n<div class=\"additionalInformation\">\n")
    ; __line = 32
    ; __append( String(model.additionalInformation).replace('{{termsUrl}}', termsUrl) )
    ; __append("\n</div>\n</div>")
    ; __line = 34
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/documents/offer/summary.ejs

}